import { extractQueryState } from "@shared/utils/extractQueryState";
import { useInfiniteQuery } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";

type PageParam = { pageParam?: { nextParam: string } };

type Params = {
  nameFilter?: string;
  emailFilter?: string;
  trackingIdFilter?: string;
  limit?: number;
  page?: number;
};

type Props = Params;

export const buildGetUsersQueryKey = (params?: Params) => {
  if (!params) return ["users"];

  if (!params.emailFilter) delete params.emailFilter;
  if (!params.nameFilter) delete params.nameFilter;
  if (!params.trackingIdFilter) delete params.trackingIdFilter;

  return ["users", { ...params }];
};

export const useGetUsers = (params?: Props) => {
  const {
    nameFilter,
    emailFilter,
    trackingIdFilter,
    limit = 10,
  } = params || {};

  const api = getUsersApiClient();
  const query = useInfiniteQuery({
    queryKey: buildGetUsersQueryKey({
      nameFilter,
      emailFilter,
      trackingIdFilter,
    }),
    queryFn: async ({ pageParam }: PageParam) => {
      try {
        return await api.userControllerListUsers({
          nextToken: pageParam?.nextParam,
          nameFilter,
          emailFilter,
          trackingIdFilter,
          limit,
        });
      } catch (error) {
        console.error("Failed to get users.", error);
        throw error;
      }
    },
    initialPageParam: { nextParam: "" },
    getNextPageParam: (lastPage) => {
      return lastPage.nextToken ? { nextParam: lastPage.nextToken } : undefined;
    },
    enabled: true,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });

  return extractQueryState(query);
};
